export default {"src":"/_next/static/media/shield.62a323cf.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};